// Generate all variant combinations from the set of options in the frontend.

export function generateVariantCombos(variantMap) {
  const optionNames = Object.keys(variantMap);

  // For double protection
  // Limit of options is 2 max
  if (optionNames.length > 2) {
    throw new Error("Too many variant options: maximum is 2.");
  }

  const valueLists = Object.values(variantMap);

  // Base case: if no options
  if (optionNames.length === 0) return [];

  // Cartesian product
  const cartesian = (arrays) => {
    return arrays.reduce(
      (acc, values) =>
        acc.flatMap((accEntry) =>
          values.map((value) => [...accEntry, value])
        ),
      [[]]
    );
  };

  const combos = cartesian(valueLists);

  return combos.map((comboValues, idx) => {
    const options = {};
    optionNames.forEach((optionName, index) => {
      options[optionName] = comboValues[index];
    });
  
    return {
      id: `variant-${idx}`,
      options,
    };
  });

}